import Component from './component'
import { connect } from 'react-redux';
import {logout} from '../../../actions/sistema'
import {showSnack} from 'react-redux-snackbar'
 
const mapStateToProps = (state) => {
    return {
        nome: state.database.informacoes.get('nome'),
        paginas: state.database.paginas.map(obj => obj? obj.toObject() : undefined)
    }
}

const mapDispatch = (d) =>({
    sair : ()=> d(logout()),
    feedback : (message) => d(showSnack(Date.now(), {
        label : message,
        timeout : 5000,
        button : {label : 'Beleza'}
    }))
})

export default connect(mapStateToProps, mapDispatch)(Component)


// WEBPACK FOOTER //
// ./src/views/administrativo/header/container.js